<template>
  <div id="Banks">
    <div id="headNav">
      <div class="leftArrow" @click="goHome">
        <van-icon name="arrow-left"/>
      </div>
      <div class="title">{{$t('message.index_grzx')}}</div>
      <div class="leftArrow"></div>
    </div>
    <div class="my">
      <div>
        <img src="../../assets/images/3x/avater.png" alt="">
        <p>ID:{{tk.phone}}</p>
      </div>
    </div>
    <p style="color: #7389A5;font-weight: bold;font-size: 0.37rem;width: 96%;margin: 0.65rem auto 0.2rem">{{$t('message.other_gj')}}</p>
    <div class="items">
      <div @click="goAddBanks" style="display: flex;align-items: center;justify-content: space-between">
        <div style="display: flex;align-items: center">
          <img src="../../assets/images/3x/m_bank.png" alt="" style="width: 0.93rem;height:0.93rem;margin-right:8px">{{$t('message.my_yhzhgl')}}
        </div>
        <div>
          <van-icon name="arrow"/>
        </div>
      </div>
<!--      <div @click="goEditPsd" style="display: flex;align-items: center;justify-content: space-between">-->
<!--        <div style="display: flex;align-items: center">-->
<!--          <img src="../../assets/images/3x/editPsd.png" alt="" style="width: 0.93rem;height:0.93rem;margin-right:8px">{{$t('message.edit_psd')}}-->
<!--        </div>-->
<!--        <div>-->
<!--          <van-icon name="arrow"/>-->
<!--        </div>-->
<!--      </div>-->
      <div @click="goService" style="display: flex;align-items: center;justify-content: space-between">
        <div style="display: flex;align-items: center">
          <img src="../../assets/images/3x/m_service.png" alt="" style="width: 0.93rem;height:0.93rem;margin-right:8px">{{$t('message.my_zxkf')}}
        </div>
        <div>
          <van-icon name="arrow"/>
        </div>
      </div>
      <div @click="showModel" style="display: flex;align-items: center;justify-content: space-between">
        <div style="display: flex;align-items: center">
          <img src="../../assets/images/3x/m_out.png" alt="" style="width: 0.93rem;height:0.93rem;margin-right:8px">{{$t('message.my_logout')}}
        </div>
        <div>
          <van-icon name="arrow"/>
        </div>
      </div>
    </div>
    <van-dialog v-model="show" title="" show-cancel-button @confirm="layOut"
                :confirm-button-text="$t('message.determine')" :cancel-button-text="$t('message.cancel')">
      <div style="padding: 1rem 0;text-align: center">{{$t('message.determine')}}{{$t('message.my_logout')}}？</div>
    </van-dialog>
  </div>
</template>

<script>
  import {isLogin, sassService} from "../../ports/port";

  export default {
    name: "banks",
    data() {
      return {
        tk: JSON.parse(localStorage.getItem("tokenAll")),
        refuse: false,
        show: false
      }

    },
    components: {},
    created() {
      this.$router.replace({
        path: this.$route.path, // 保留当前路径
        query: {
          ...this.$route.query, // 保留已有的 query 参数
          chntoken: sessionStorage.getItem('chntoken')  // 添加新的参数
        }
      });
      sassService({userid:this.tk.userid})
        .then((res)=>{
          if(res.data.code==200){
            this.refuse=true;
          }
        })
    },
    methods: {
      showModel() {
        this.show = true;
      },
      goAddBanks() {
        this.$router.push('/home/my/setBanks')
      },
      goEditPsd() {
        this.$router.push('/editPsd')
      },
      goHome() {
        this.$router.push('/home')
      },
      goService() {
        if (this.refuse) {
          this.$router.push('/home/my/service')
        }
      },
      //退出
      layOut() {
        isLogin({userid:this.tk.userid})
          .then(res=>{ });
        localStorage.removeItem('tokenAll');
        localStorage.removeItem('broadcast');
        sessionStorage.removeItem('hasRegD');
        sessionStorage.removeItem('chntokenOther');
        sessionStorage.removeItem('aff_sid');
        this.$router.push({path:'/',query:{chntoken:sessionStorage.getItem('chntoken')}});
      },
    }
  }
</script>

<style scoped lang="scss">
  #Banks {
    background: #F2F4FB;
    min-height: 100vh;

    .items {
      /*background: #fff;*/
      > div {
        padding: 0.3rem;
        border-bottom: 1px solid #f3f1f1;
        background: #fff;
        width: 96%;
        margin: 0 auto 10px;
        box-sizing: border-box;
        border-radius: 8px;
        /*box-shadow: 0px 0px 7px #d8d5d5;*/

      }
    }

    .my {
      /*background: #fff;*/
      background: url("../../assets/images/3x/mine_top.png") left top no-repeat;
      background-size: cover;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      height: 6.25rem;
      margin-bottom: 1.5rem;
      position: relative;

      > div {
        width: 90%;
        height: 5.01rem;
        background: #fff;
        border-radius: 8px;
        position: absolute;
        top: 2.2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        img {
          width: 2.35rem;
          height: 2.35rem;
        }

        p {
          font-size: 0.37rem;
          font-weight: bold;
          color: #00154E;
          margin-top: 0.67rem;
        }
      }
    }
  }

  #logout {
    @include defaultBtn
  }

  .circle {
    width: 4px;
    height: 4px;
    border-radius: 4px;
    background: #fff;
    display: inline-block;
    margin: 0 15px;
  }

  #headNav {
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 5;
    display: flex;
    align-content: center;
    justify-content: space-between;
    padding: 0 10px;
    height: 57px;
    line-height: 57px;
    /*background: rgba(0,0,0,0.1);*/
    color: #fff;

    .title {
      font-size: 18px;
      color: #fff;
      font-weight: 500;
    }

    .leftArrow {
      font-size: 18px;
      display: flex;
      align-items: center;
      width: 40px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/home/my.vue